/**
 * Las rutas de admin que el portal del perito entiende (auditoría del portal del
 * perito, 26-09-2026: A20/T04-02, T15-02, T15-03 y M10/T03-04).
 *
 * Varias piezas COMPARTIDAS con el admin navegan a rutas fijas de admin: el
 * «Ver tarea» de la voz (`/planner?taskId=…`), el «Crear tratamiento» del
 * muestreo (`/pests?tab=scouting&session=…&action=createTreatment`), el
 * «Ver Inventario» de «Stock insuficiente» (`/inventory`) y los avisos viejos
 * guardados con `route: "/planner"`. El portal del perito no tiene esas rutas y
 * su comodín le devolvía al Inicio PERDIENDO la `?`: la tarea se creaba pero la
 * ficha no se abría nunca.
 *
 * En vez de enseñar a cada pieza en qué portal está, el portal traduce: la
 * misma dirección, con su consulta y su ancla, en la pantalla del perito que
 * hace lo mismo. Lo que no está aquí sigue yendo al Inicio.
 */

/** Prefijo de admin → prefijo del perito. El orden importa: el más largo antes. */
const ALIAS: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
  [/^\/inventory\/([^/]+)\/?$/, (m) => `/perito/inventario/${m[1]}`],
  [/^\/inventory\/?$/, () => "/perito/inventario"],
  [/^\/planner\/?$/, () => "/perito/planificador"],
  [/^\/tasks\/?$/, () => "/perito/planificador"],
  [/^\/pests\/?$/, () => "/perito/sanidad"],
  [/^\/dashboard\/?$/, () => "/perito/inicio"],
  [/^\/notifications\/?$/, () => "/perito/notificaciones"],
  [/^\/profile\/?$/, () => "/perito/perfil"],
];

/**
 * A dónde lleva una ruta de admin en el portal del perito, CON su consulta y su
 * ancla; `null` si no tiene equivalente (el router la manda al Inicio).
 */
export function aliasDelPerito(pathname: string, search = "", hash = ""): string | null {
  for (const [re, to] of ALIAS) {
    const m = pathname.match(re);
    if (!m) continue;
    const destino = to(m);
    /* La pestaña de tratamientos del admin es, en Sanidad del perito, la
       ventana de recetas (`?tab=recetas`). */
    let consulta = search;
    if (destino === "/perito/sanidad" && search) {
      const q = new URLSearchParams(search);
      if (q.get("tab") === "treatments") q.set("tab", "recetas");
      consulta = `?${q.toString()}`;
    }
    return `${destino}${consulta}${hash}`;
  }
  return null;
}
